<template>
  <!-- 优惠券详情页面 -->
  <div class="couponDetail">
    <section class="planInfoBox">
      <!-- 优惠券信息 -->
      <div class="couponBox">
        <couponCard :datas="datas" :isDetail="true">
          <!-- <couponBtn :data="cardBtn" @click="clickBtn($event, datas)" /> -->
        </couponCard>
      </div>

      <!-- 经销商 -->
      <div class="dealerInfoBox">
        <CurrentDealer v-if="distributeTypeFlag === 1" :updataDealer="updataDealer" from="coupon">
          <template #colLabel>适用经销商 </template>
        </CurrentDealer>
        <CurrentDealer v-if="distributeTypeFlag === 2" :updataDealer="updataDealer" from="coupon">
          <template #colLabel>浏览经销商 </template>
          <template #noDealer><span></span> </template>
          <template #currentDealer> <span></span></template>
          <template #afterName> <span></span></template>
        </CurrentDealer>
      </div>
    </section>

    <section class="cellBox">
      <!-- 描述说明信息 -->
      <van-collapse v-model="discrptionuseCollapse">
        <van-collapse-item title="优惠券描述" name="1">
          <div class="accordionContent" v-html="datas.description || '暂无优惠券描述'"></div>
        </van-collapse-item>
      </van-collapse>
      <van-collapse v-model="useCollapse">
        <van-collapse-item title="使用限制说明" name="1">
          <div class="accordionContent" v-html="datas.useDescription || '暂无使用限制说明'"></div>
        </van-collapse-item>
      </van-collapse>
      <van-cell title="领取数量">
        <van-stepper v-model="couponNum" :max="stepperMaxNum" :min="stepperMinNum" button-size="20" disable-input @change="changeNum" />
      </van-cell>
    </section>

    <van-dialog
      v-model:show="isShowDialog"
      title=""
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="dialogContent">
        <h3 class="title" v-if="dialogConfig.title">
          {{ dialogConfig.title }}
        </h3>
        <div v-html="dialogConfig.content"></div>
      </div>
    </van-dialog>
  </div>
  <!-- 底部按钮 -->

  <section class="bottomWrap">
    <couponBtn :data="toMyBtnData" @click="toMyCouponList"> <van-icon name="coupon-o" size="26" /><span>我的优惠券</span> </couponBtn>
    <couponBtn :data="[bottomBtnData]" v-if="bottomBtnData.text" @click="clickBtn($event, datas)">
      {{ isChecking ? '信息校验中,请稍候....' : bottomBtnData.text }}
    </couponBtn>
  </section>

  <van-overlay :show="showFullLoad" z-index="10000" :custom-style="{ height: '100vh', opacity: 0.8 }">
    <div class="wrapper" @click="showFullLoad = false">
      <van-loading size="24px" vertical>数据加载中...</van-loading>
    </div>
  </van-overlay>
</template>

<script>
import { reactive, toRefs, onMounted, watch, nextTick, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import { useStore } from 'vuex'
import { getPurchaseAmount, getPurchase, getCouponDetail } from '@/api/couponCollection'
import couponCard from '@/components/couponCollection/CouponCard'
import couponBtn from '@/components/order/BottomBtn'
import { showToast, couponBtn as getCouponBtn, setCouponBtn, reorganizeListData } from '@/util/couponCollection'
import { getDefaultDealer } from '@/api/tyre'
import { getDealers } from '@/api/plan'
import { getDistance } from '@/util'
import _ from 'lodash'
export default {
  name: 'couponDetail',
  components: { CurrentDealer, couponBtn, couponCard },
  setup() {
    const route = useRoute()
    let router = useRouter()
    const store = useStore()
    let { from, gsCode = '', couponId } = route.query
    let joinCouponFlag = from === 'couponList' || from === 'home'
    const state = reactive({
      from,
      couponId,
      datas: {},
      cardBtn: [],
      bottomBtnData: { text: '', type: 'active', size: 'large' },
      discrptionuseCollapse: ['1'],
      useCollapse: ['1'],
      joinCouponFlag,
      isShowDialog: false,
      isChecking: false,
      dialogConfig: {
        title: '确认领取',
        confirmButtonText: '确认领取',
        cancelButtonText: '暂不领取'
      },
      stepperMinNum: 0,
      stepperMaxNum: 0,
      distributeTypeFlag: 0, // 发放方式标识{1：按经销商发放 2：厂家直接发放}
      couponNum: 0, //当前stepper选择的数量
      purchaseLimitPerCustomer: 1, //优惠券领取限制
      canPurchaseAmount: 0, //当前用户剩余可领取数量
      residueCount: 0, //当前经销商剩余领取
      totalResidueCount: 0, // 经销商的总剩余领取
      updataDealer: 0,
      toMyBtnData: [{ type: 'plain', size: 'large', path: '/myCouponList' }],
      showFullLoad: true,
      isCheck: false
    })
    //关闭弹窗
    const beforeCloseDialog = async action => {
      if (action === 'confirm') {
        try {
          state.bottomBtnData = {
            text: '正在领取...',
            type: 'unabled',
            size: 'large',
            en: 'purchase'
          }
          const dealerInfo = store.state.loyaltyDealerInfo || {}
          const gsCode = state.distributeTypeFlag === 1 ? dealerInfo?.gs_code || dealerInfo?.gsCode : ''
          let param = {
            couponId: state.couponId,
            receiveAmount: state.couponNum,
            gsCode
          }
          await getPurchase(param)
          let msg = `已成功领取${state.couponNum}张优惠券！</br>可前往“我的优惠券”查看`
          state.bottomBtnData = {
            text: '领取成功',
            type: 'unabled',
            size: 'large'
          }
          showToast(msg, {
            type: 'html',
            duration: 3000,
            onClose: refreshPage
          })
          return true
        } catch (e) {
          showToast(e.message, '领取失败')
          resetBtnStatus(e)
          // canPurchaseAmount 当前用户剩余可领取数量  residueCount 剩余库存数量
          let {
            statusCode,
            data: { canPurchaseAmount, residueCount }
          } = e
          if (statusCode === 802) {
            // 已领光
            resetBtnStatus(e)
          } else {
            if (residueCount <= 0) {
              // 已领光
              state.bottomBtnData = getCouponBtn('nullBtn', { text: '已领光', size: 'large' })
              state.isShowDialog = false
            }
            if (residueCount > 0) {
              if (canPurchaseAmount > 0) {
                let stepperMaxNum = Math.min.apply(Math, [residueCount, canPurchaseAmount, state.stepperMaxNum])
                state.stepperMaxNum = stepperMaxNum
                state.bottomBtnData = getCouponBtn('getBtn', { text: '免费领取', size: 'large' })
              } else {
                await refreshPage()
                state.isShowDialog = false
              }
            }
          }
        }
      }
      if (action === 'cancel') {
        state.bottomBtnData.en == 'purchase' && (state.bottomBtnData = getCouponBtn('getBtn', { text: '免费领取', size: 'large' }))
        return true
      }
    }
    // 刷新页面数据
    const refreshPage = async () => {
      state.bottomBtnData = {
        text: '数据正在刷新',
        type: 'unabled',
        size: 'large'
      }
      try {
        await getCouponDetailFn()
      } catch (e) {
        console.error(e.message || '获取详情数据失败')
        state.bottomBtnData = {
          text: '数据刷新失败',
          type: 'disabled',
          size: 'large'
        }
      }
    }
    // 修改数量
    const changeNum = _.debounce(async v => {
      if (v > state.stepperMaxNum) {
        state.stepperMaxNum && showToast(`当前最多可领取${state.stepperMaxNum}张`)
        state.couponNum = state.stepperMaxNum
      }
    }, 600)

    // 获取优惠券详情信息
    const getCouponDetailFn = async () => {
      try {
        let data = await getCouponDetail({ id: state.couponId })
        let temp = reorganizeListData([data])[0] || {}
        state.datas = temp
        // 发放方式标识{1：按经销商发放 2：厂家直接发放}
        state.distributeTypeFlag = temp.distributeTypeFlag
        state.purchaseLimitPerCustomer = temp.purchaseLimitPerCustomer
        if (temp.distributeTypeFlag === 1) {
          setPurchaseAmountFn(true)
        }
        if (temp.distributeTypeFlag === 2) {
          //厂家直接发放,需要计算当前用户剩余可领取数量
          let statisInfo = temp.statisInfo || {}
          store.commit('SETDEALERfREEZEFLAG', false)
          state.canPurchaseAmount = statisInfo.canPurchaseAmount
          nextTick(() => {
            let stepperMaxNum = setStepperMaxNum()
            stepperMaxNum && (state.couponNum = 1)
          })
          // 设置按钮
          let cardBtn = setCouponBtn(temp)
          if (temp.activeStatusFlag !== 2) {
            cardBtn = {}
          }
          state.cardBtn = [cardBtn]
          state.bottomBtnData = Object.assign(_.clone(cardBtn), {
            size: 'large'
          })
        }
      } catch (e) {
        showToast(e.message, '获取详情数据失败')
        state.datas = {}
        state.cardBtn = []
        state.bottomBtnData = { text: '', type: 'active', size: 'large' }
      }
    }

    // 点击按钮
    let clickBtn = (v, data) => {
      // console.log("--clickBtn-->", v, data);
      if (state.isChecking) return
      if (v.type != 'active') return
      if (!state.couponNum) {
        showToast('请修改领取数量')
        return false
      }
      const dealerInfo = store.state.loyaltyDealerInfo
      if (state.distributeTypeFlag === 1) {
        const gsCode = dealerInfo?.gs_code || dealerInfo?.gsCode
        if (!dealerInfo || !gsCode) {
          showToast('请先选择一个适合的经销商')
          return false
        }
        // state.dialogConfig.content = `确认领取${state.couponNum}张仅适用于${dealerInfo.name}的${data.rightName}优惠券？`
        // state.dialogConfig.content = `您正在领取仅适用于<br/>${store.state.loyaltyDealerInfo.name}<br/>的优惠券，确认领取吗？`
        state.dialogConfig.content = `您正在领取仅适用于${dealerInfo.name}的优惠券，确认领取吗？`
        state.dialogConfig.title = `确认经销商`
      } else {
        state.dialogConfig.content = `确认领取${state.couponNum}张${data.rightName}优惠券？`
      }
      nextTick(() => {
        state.isShowDialog = true
      })
    }
    // 校验经销商是否在许可范围
    let checkCouponByDealer = async dealerInfo => {
      if (state.distributeTypeFlag !== 1) {
        return false
      }
      const gsCode = dealerInfo?.gs_code || dealerInfo?.gsCode
      if (!gsCode) {
        // showToast('请先选择经销商')
        return false
      }
      state.isChecking = true
      try {
        await setPurchaseAmountFn(true)
        state.isChecking = false
      } catch (e) {
        state.isChecking = false
        showToast(e.message, '校验失败')
      }
    }
    // 设置当前用户剩余可领取数量/当前经销商剩余领取
    let setPurchaseAmountFn = async isShowToast => {
      state.isCheck = true
      try {
        // 根据经销商获取当前优惠券统计数量
        const dealerInfo = store.state.loyaltyDealerInfo || {}
        const gsCode = state.distributeTypeFlag === 1 ? dealerInfo?.gs_code || dealerInfo?.gsCode : ''
        if (state.distributeTypeFlag !== 1 || !gsCode) {
          return false
        }
        let param = {
          couponId: state.couponId,
          gsCode
        }
        let { canPurchaseAmount = 0, residueCount = 0 } = await getPurchaseAmount(param)
        //当前经销商剩余领取
        state.residueCount = residueCount
        //当前用户剩余可领取数量
        state.canPurchaseAmount = canPurchaseAmount
        nextTick(() => {
          setStepperMaxNum()
        })
        resetBtnStatus({ statusCode: 200 })
      } catch (e) {
        resetBtnStatus(e, isShowToast)
      }
    }
    // 重置按钮状态
    const resetBtnStatus = ({ statusCode, message = '' }, isShowToast) => {
      // 801 不参加活动 802 已领光 803 当前微信号在该家经销商已达领取上限
      let text = ''
      let name = ''
      let joinCouponFlag = true
      switch (statusCode) {
        case 200:
          text = '免费领取'
          name = 'getBtn'
          break
        case 801:
          text = '不参加活动'
          name = 'nullBtn'
          state.isShowDialog = false
          joinCouponFlag = false
          break
        case 802:
          text = '已领光'
          name = 'nullBtn'
          state.isShowDialog = false
          break
        case 803:
          text = `已领取${state.purchaseLimitPerCustomer}/${state.purchaseLimitPerCustomer}`
          name = 'nullBtn'
          state.isShowDialog = false
          break
      }
      state.joinCouponFlag = joinCouponFlag
      if (state.datas && state.datas.activeStatusFlag !== 2) {
        state.bottomBtnData = { text: '', type: 'active', size: 'large' }
        state.cardBtn = []
        return false
      }
      if (text) {
        state.bottomBtnData = getCouponBtn(name, { text, size: 'large' })
        state.cardBtn = [getCouponBtn(name, { text })]
      }
      if (isShowToast && statusCode != 801) {
        showToast(message, '校验失败')
      }
    }
    // 获取默认经销商
    const getDefaultDealerFn = async () => {
      let { loyaltyDealerInfo: dealerInfo } = store.state
      dealerInfo = dealerInfo || {}
      if (!dealerInfo.gsCode && !dealerInfo.gs_code) {
        try {
          let { lat: latitude, lng: longitude } = store.state.position
          let param = { latitude, longitude, productType: 3 }
          let data = await getDefaultDealer(param)
          if (data && data.gsCode) {
            dealerInfo = { ...data, gs_code: data.gsCode }
            store.dispatch('setLoyaltyDealerInfo', dealerInfo)
          }
          if ((!data || !data.gsCode) && (!latitude || !longitude)) {
            store.dispatch('setLoyaltyDealerInfo', {})
            showToast('无法定位所在地点，请手动选择经销商后查看相关信息')
          }
        } catch (e) {
          showToast(e.message, '获取默认经销商失败')
        }
      }
      if (!dealerInfo.distance) {
        let gs_code = dealerInfo.gsCode || dealerInfo.gs_code
        if (!gs_code) return
        try {
          await getDealerDistanceFn(gs_code)
        } catch (e) {
          showToast(e.message, '获取经销商距离失败')
        }
      }
    }
    // 获取经销商距离等信息
    const getDealerDistanceFn = async gs_code => {
      let { lat, lng } = store.state.position
      let params = { gsCode: gs_code, latitude: lat, longitude: lng, couponId }
      try {
        let { list = [] } = await getDealers(params)
        let dealer = list && list.length === 1 ? list[0] : {}
        dealer.distance = getDistance(dealer.distance)
        let _gsCode = dealer.gs_code || dealer.gsCode
        dealer.gs_code = dealer.gsCode = _gsCode
        store.dispatch('setLoyaltyDealerInfo', dealer)
      } catch (e) {
        showToast(e.message, '获取经销商距离失败')
        store.dispatch('setLoyaltyDealerInfo', {})
      }
    }
    // 设置gsCode，防止加载默认经销商
    gsCode && store.dispatch('setDealerInfo', { gs_code: gsCode })
    const initByfrom = async () => {
      const isScan = from === 'scan' || from === 'QRcode'
      // isSperate 是否运营
      const isFreeze = Boolean(isScan && gsCode)
      store.commit('SETDEALERfREEZEFLAG', isFreeze)
      console.log('isFreeze--->', isFreeze)
      if (isFreeze) {
        // await getDealerFn()
        await getDealerDistanceFn(gsCode)
      } else {
        await getDefaultDealerFn()
      }
    }
    const getDealerFn = async () => {
      try {
        let { lat, lng } = store.state.position
        let { list = [] } = await getDealers({
          gsCode,
          couponId,
          latitude: lat,
          longitude: lng
        })
        const dealerInfo = list[0] || {}
        dealerInfo.distance = getDistance(dealerInfo.distance)
        store.dispatch('setLoyaltyDealerInfo', { ...dealerInfo, gs_code: gsCode, gsCode })
      } catch (e) {
        showToast(e.message, '获取经销商详情失败')
        store.dispatch('setLoyaltyDealerInfo', {})
      }
    }
    watch(
      () => store.state.position,
      (n, o) => {
        // 初始化刷新经销商距离
        console.log('初始化后刷新', n)
        // n && n.lat && gsCode && getDealerFn()
        let nLat = (n && n.lat) || ''
        let oLat = (o && o.lat) || ''
        let { loyaltyDealerInfo: dealerInfo } = store.state
        let gs_code = dealerInfo.gsCode || dealerInfo.gs_code
        let _gsCode = gsCode || gs_code
        nLat && nLat !== oLat && _gsCode && !dealerInfo.distance && getDealerDistanceFn(_gsCode)
      },
      { deep: true }
    )

    onMounted(async () => {
      store.commit('SETCOUPONID', state.couponId)
      try {
        await initByfrom()
        await getCouponDetailFn()
      } finally {
        state.showFullLoad = false
        setTimeout(() => {
          if (!state.isCheck) {
            setPurchaseAmountFn()
          }
        }, 3000)
      }
    })
    onUnmounted(() => {
      store.commit('SETCOUPONID', '')
      store.commit('SETDEALERfREEZEFLAG', false)
    })
    watch(
      () => store.state.loyaltyDealerInfo,
      (n, o) => {
        // 校验经销商是否在许可范围
        n && checkCouponByDealer(n)
        let nGscode = n.gsCode || n.gs_code || ''
        let oGscode = o.gsCode || o.gs_code || ''
        nGscode && oGscode !== nGscode && getDealerDistanceFn(nGscode)
      },
      { deep: true }
    )

    // 可领最大数
    const setStepperMaxNum = () => {
      //当前用户剩余可领取数量  canPurchaseAmount
      let arr = []
      if (state.distributeTypeFlag === 1) {
        // 按经销商发放---单个微信号剩余可领取数量”和“当前经销商剩余可领取数量”的更小值
        arr = [state.canPurchaseAmount, state.residueCount]
      }
      if (state.distributeTypeFlag === 2) {
        // 厂家发放的优惠券--单个微信号剩余可领取数量”和“所有剩余可领取数量”的更小值
        let statisInfo = state.datas.statisInfo || {}
        arr = [state.canPurchaseAmount, statisInfo.totalResidueCount || 0]
      }
      let stepperMaxNum = Math.min.apply(Math, arr)
      state.stepperMaxNum = stepperMaxNum
      state.stepperMinNum = stepperMaxNum > 0 ? 1 : 0
      if (stepperMaxNum && !state.couponNum) {
        state.couponNum = 1
      }
      return stepperMaxNum
    }
    watch(
      () => state.joinCouponFlag,
      n => {
        store.commit('SETJOINCOUPONFLAG', n)
      },
      { immediate: true }
    )
    // 跳转我的优惠券
    let toMyCouponList = ({ path }) => {
      router.push({ path, query: { event: '我的优惠券列表' } })
    }

    return {
      ...toRefs(state),
      getCouponDetailFn,
      clickBtn,
      beforeCloseDialog,
      changeNum,
      setStepperMaxNum,
      toMyCouponList
    }
  }
}
</script>

<style lang="scss" scoped>
.couponDetail {
  height: 100%;
  background-color: #f5f5f5;
  padding-bottom: 150px;
  text-align: left;
  .dealerInfoBox {
    padding: 18px 20px 10px;
    background-color: #fff;
  }
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 24px 20px 12px;
    color: #666;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
    .title {
      margin-bottom: 10px;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
    }
  }
}
.couponBox {
  padding: 20px;
}

// 经销商样式
.dealerInfoBox {
  .label {
    font-size: 14px;
    color: #333;
    line-height: 30px;
  }
  .van-divider {
    margin: 8px 0;
  }
}
.cellBox {
  padding: 0 10px;
  background: #fff;
  :deep(.van-cell) {
    padding: 10px;
  }
}

.accordionContent {
  width: 100%;
  :deep(p) {
    word-break: break-all;
  }
  :deep(a) {
    color: #969799;
  }
}
.bottomWrap {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  padding: 16px 20px 30px;
  background-color: #f5f5f5;
  .btnCompnentBox + .btnCompnentBox {
    margin-top: 8px;
  }
  .van-badge__wrapper {
    margin-right: 10px;
    vertical-align: middle;
  }
  .span {
    vertical-align: middle;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
